/* @ngInject */
const contact = (
  $$phone,
  $$email,
  contactAsk,
  contactData,
  contactFormat,
  contactGo,
  contactLocal,
  contactMetadata,
  contactRequest
) => {
  const self = {}

  self.new = () => {
    return {
      lastname: null,
      firstname: null,
      function: null,
      comment: null,
      ownerId: null,
      phones: [$$phone.new(),],
      emails: [$$email.new(),],
    }
  }

  self.ask = contactAsk
  self.data = contactData
  self.format = contactFormat
  self.go = contactGo
  self.local = contactLocal
  self.metadata = contactMetadata
  self.request = contactRequest

  return self
}

export default contact



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/contact.service.js